import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57404e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-organizations-detail-information" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Općenito ", -1))
const _hoisted_5 = { class: "box__information" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "address" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorOrganizationsDetailInformationFormUpdateIndexVue = _resolveComponent("AppAdministratorOrganizationsDetailInformationFormUpdateIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorOrganizationsDetailInformationFormUpdateIndexVue, {
          organizationInformation: _ctx.organizationInformation,
          onGetOrganizationInformation: _ctx.getOrganizationInformation
        }, null, 8, ["organizationInformation", "onGetOrganizationInformation"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.organizationInformation.content.name), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.organizationInformation.content.address) + ", " + _toDisplayString(_ctx.organizationInformation.content.city) + ", " + _toDisplayString(_ctx.organizationInformation.content.country), 1)
          ])
        ])
      ])
    ])
  ]))
}